import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../images/logos/logo_1.png'
import { useTranslation } from "react-i18next";

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = () => {
    const { t } = useTranslation();

    return (
        <footer className="footer footer--minimal">
            <div className="container">
                <div className="footer__minimalMain">
                    <Link
                        className="footer__minimalBrand"
                        onClick={ClickHandler}
                        to="/"
                        aria-label={t("footer_home")}
                    >
                        <img src={logo} alt="KAED" className="footer__minimalLogo" />
                    </Link>

                    <nav className="footer__minimalNav" aria-label={t("footer_quicklinks")}>
                        <Link onClick={ClickHandler} to="/">{t("menu_home")}</Link>
                        <Link onClick={ClickHandler} to="/about">{t("menu_about")}</Link>
                        <Link onClick={ClickHandler} to="/events">{t("menu_events")}</Link>
                        <Link onClick={ClickHandler} to="/announcements">{t("menu_announcements")}</Link>
                        <Link onClick={ClickHandler} to="/blog">{t("menu_blog")}</Link>
                        <Link onClick={ClickHandler} to="/contact">{t("footer_contact")}</Link>
                    </nav>

                    <div className="footer__minimalActions">
                        <a href="mailto:info@kaed.org.tr" className="footer__minimalEmail">
                            <i className="fa-solid fa-envelope" aria-hidden="true"></i>
                            <span>info@kaed.org.tr</span>
                        </a>
                    </div>
                </div>

                <div className="footer__minimalBottom">
                    <p>{t("footer_copyright")}</p>
                    <Link onClick={ClickHandler} to="/privacy">{t("footer_privacy_policy")}</Link>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
